import React from 'react'
import { Container, Col, Row, Image } from "react-bootstrap";
import { FaPhoneAlt } from "react-icons/fa";
import { GrMail } from "react-icons/gr";
const ImportantCBConcierge = () => {
  return (
   <>
   <section className='cbr_imp_cb_Coinserge'>
    <Container>
    <Row>
        <Col lg={8} md={12} sm={12} className='text-center m-auto'>
         <div className='cbr_importntat'>
         <h2>Important CB Concierge Contact Info:</h2>
         <h4><a href="tel: +1 (678) 722-5664">
            {/* <i className="fa fa-phone"></i> */}
            <FaPhoneAlt />
            (678) 722-5664</a>
            </h4>
            <h4><a href="mailto: sales@culturedbrilliance.com">
                {/* <i className="fa fa-envelope"></i> */}
                <GrMail />
                sales@culturedbrilliance.com</a></h4>
         </div>
        </Col>
    </Row>
    </Container>
   </section>
   </>
  )
}

export default ImportantCBConcierge
